import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import OfferBackground from "../../../assets/images/blur_store.png";
import GreenBtn from "../../../assets/images/btn_green_store.png";
import RedBtn from "../../../assets/images/btn_red_store.png";
import {numberSplitor} from "../../../Utility/Func";

class SingleOffer extends React.Component {
    constructor() {
        super();
        this.state = {
            style:{

            },

        }
    }
    componentDidMount() {
        // console.log(this.props.data)
    }
    render() {
        const {
            //default
            // OfferBackground,
            GoldCoin,
            Box,
            // GreenBtn,
            price,
            //from api
            qIcon,
            fullPrice,
            icon,
            quantity
        }=this.props.data
        return(
                <Grid alignItems='center' direction={"column"} container sm={12} item justify='space-around'
                      className='offer-section-single-offer'
                      style=
                          {{
                              backgroundImage:"url("+OfferBackground+")",
                              // backgroundColor:'rgba(0,0,0,0.3)'
                          }}
                >
                    {/*<img src={OfferBackground} className='offer-section-single-offer-background' alt=""/>*/}
                    <Grid style={{backgroundColor:''}} item container justify={"center"} alignItems={"center"} >
                        <Grid
                            // style={{height:'80px'}}
                              sm={4} xs={4} item container justify={"center"} alignItems={"center"}>
                            <img src={icon} className='offer-section-single-offer-image' alt=""/>
                        </Grid>
                    </Grid>
                    <Grid style={{backgroundColor:''}} direction={"column"} container alignItems={"center"} justify={"center"} >
                        <Grid style={{backgroundColor:''}} container alignItems={"center"} justify={"center"}>
                            <Grid sm={2} xs={2} item container justify={"center"} alignItems={"center"}>
                                <img src={qIcon} className='offer-section-single-offer-gold-coin-icon' alt=""/>
                            </Grid>
                            <Grid sm={3} xs={3} item container justify={"center"} alignItems={"center"}>
                                <p>
                                    {quantity}
                                </p>
                            </Grid>
                        </Grid>
                        {
                            (fullPrice!=='' && price!=='') &&
                            <Grid style={{backgroundColor:''}} className='offer-section-single-offer-full-price' container alignItems={"center"} justify={"center"}>
                            <span  className='offer-section-single-offer-span-outer'>
                                <span className='offer-section-single-offer-span-inner'>
                                    {fullPrice!='0'?numberSplitor(fullPrice):''}
                                </span>
                            </span>
                            </Grid>
                        }
                    </Grid>
                    {
                        (fullPrice!=='' && price!=='') &&
                        <Grid style={{
                            backgroundImage:"url("+(fullPrice===0?GreenBtn:RedBtn)+")",
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '50% 50%',
                            // width:'15%'
                            backgroundColor:''
                        }} container
                              justify={"center"} alignItems={"center"}
                              className='offer-section-single-offer-price-section'
                              direction={"row-reverse"}
                        >
                            <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                <p className='offer-section-single-offer-text'>
                                    {numberSplitor(price)}
                                </p>
                            </Grid>
                            <Grid container alignItems={"center"} justify={"center"} sm={1} xs={1}/>
                            <Grid container alignItems={"center"} justify={"center"} sm={3} xs={3}>
                                <p className='offer-section-single-offer-text'>
                                    تومان
                                </p>
                            </Grid>
                        </Grid>
                    }
                </Grid>
        )
    }
}
export default SingleOffer